import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SiteHeaderState {
  isTimelineOpen: boolean
  isCustomerInfoOpen: boolean
  isChatOpen: boolean
}

const initialState: SiteHeaderState = {
  isTimelineOpen: false,
  isCustomerInfoOpen: false,
  isChatOpen: false
}

const siteHeaderSlice = createSlice({
  name: 'siteHeader',
  initialState,
  reducers: {
    // The only writer is useTimelineOpen (which also persists the preference)
    // plus AppSectionLayout's one-shot seed — user-facing toggles must go
    // through the hook, or the change silently doesn't survive a reload.
    setTimelineOpen: (state, action: PayloadAction<boolean>) => {
      state.isTimelineOpen = action.payload
    },
    // Chat is a floating card now and the viewer can move or resize it off whatever it
    // covers — so timeline and chat are now independent.
    setChatOpen: (state, action: PayloadAction<boolean>) => {
      state.isChatOpen = action.payload
    },
    toggleChat: (state) => {
      state.isChatOpen = !state.isChatOpen
    }
  }
})

export const { setTimelineOpen, setChatOpen, toggleChat } =
  siteHeaderSlice.actions

export const siteHeaderReducer = siteHeaderSlice.reducer

type StateSlice = { siteHeader: SiteHeaderState }

export const selectIsTimelineOpen = (state: StateSlice) =>
  state.siteHeader.isTimelineOpen
export const selectIsChatOpen = (state: StateSlice) =>
  state.siteHeader.isChatOpen
